module.exports = __webpack_public_path__ + "img/single_paragraph.0bd7d233.svg";